<ion-header>
  <ion-toolbar mode="ios">
    <ion-title text-center> Select a date to reschedule </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon
          class="position-rule"
          slot="icon-only"
          name="close-circle"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="inner-content" padding="">
    <ion-grid>
      <ion-row *ngIf="timeSlots?.length > 0; else noTimeSlotes">
        <ion-col size="12">
          <ion-radio-group [(ngModel)]="selectedTimeSlotId">
            <ion-grid no-padding>
              <ion-row>
                <ion-col
                  *ngFor="let time of timeSlots"
                  size="3"
                  (click)="time?.available ? selectTimeSlot(time) : ''"
                >
                  <div
                    [ngClass]="time?.available ? 'date' : 'date-disabled'"
                    card-like=""
                  >
                    <div
                      class="item-radio-selectable"
                      [ngClass]="{
                        'item-radio-selected': time?.id === selectedTimeSlotId
                      }"
                    >
                      <div style="padding-top: 8px; padding-bottom: 8px">
                        <ion-radio
                          mode="ios"
                          [disabled]="!time.available"
                          [value]="time.id"
                        ></ion-radio>
                        <ion-text
                          [ngClass]="{ 'text-color': !time?.available }"
                          [color]="
                            time?.id === selectedTimeSlotId ? 'light' : 'medium'
                          "
                          text-small
                          *ngIf="time?.isToday"
                          >Today</ion-text
                        >
                        <ion-text
                          [ngClass]="{ 'text-color': !time?.available }"
                          [color]="
                            time?.id === selectedTimeSlotId ? 'light' : 'medium'
                          "
                          text-small
                          *ngIf="time?.isTomorrow"
                          >Tomorrow</ion-text
                        >
                        <ion-text
                          [ngClass]="{ 'text-color': !time?.available }"
                          [color]="
                            time?.id === selectedTimeSlotId ? 'light' : 'medium'
                          "
                          text-small
                          *ngIf="!time?.isToday && !time?.isTomorrow"
                        >
                          {{ time?.startTime | date: "dd MMM" }}
                        </ion-text>
                      </div>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-radio-group>
        </ion-col>
      </ion-row>
      <ng-template #noTimeSlotes>
        <div
          style="
            height: 60vh;
            display: flex;
            width: 100%;
            flex-direction: column;
          "
          align-items-center
          justify-content-center
        >
          <div text-center *ngIf="timeSlots === null">
            <ion-spinner></ion-spinner><br />
            <div font-medium>Fetching time slots...</div>
          </div>
          <div text-center *ngIf="timeSlots?.length === 0">
            <h2 font-medium>No Time slots</h2>
            <p>There are no Time slots. Please contact your admin.</p>
          </div>
        </div>
      </ng-template>
    </ion-grid>
  </div>
</ion-content>

<ion-footer no-box-shadow="" *ngIf="timeSlots?.length > 0">
  <ion-grid>
    <ion-row>
      <ion-col size="4" class="ion-text-center">
        <div class="input-color">
          <ion-text class="text-position" color="medium"
            >Slot Available</ion-text
          >
          <div class="color-box active"></div>
        </div>
      </ion-col>
      <ion-col size="4">
        <div class="input-color">
          <ion-text class="text-position" color="medium"
            >Slot Disabled</ion-text
          >
          <div class="color-box disabled"></div>
        </div>
      </ion-col>
      <ion-col size="4">
        <div class="input-color">
          <ion-text class="text-position" color="medium"
            >Slot Selected</ion-text
          >
          <div class="color-box selected"></div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-button
          [color]="'primary'"
          recykal-button=""
          centered=""
          expand="block"
          size="large"
          [disabled]="!selectedTimeSlotId"
          (click)="updateTimeSlot()"
          >Reschedule</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
